import { render } from "./designCheckbox.vue?vue&type=template&id=5f30cf7e&scoped=true"
import script from "./designCheckbox.vue?vue&type=script&lang=js"
export * from "./designCheckbox.vue?vue&type=script&lang=js"

import "./designCheckbox.vue?vue&type=style&index=0&id=5f30cf7e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f30cf7e"]])

export default __exports__